enum ErrorCategory {
  API = 'api',
  UI = 'ui',
  AUTH = 'auth',
  DATABASE = 'database',
  NETWORK = 'network',
  CACHE = 'cache',
  PRODUCT = 'product',
  BASKET = 'basket',
  SAVEFORLATER = 'saveForLater',
  PAYMENT = 'payment',
  SYSTEM = 'system',
  CLIENT = 'client',
  UNKNOWN = 'unknown',
}

export default ErrorCategory;
